export default "__VITE_ASSET__k0M7vbIJ__"